import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {ticketOrders, vasOrders, order, orderDeliver, payinfo, orderUpdateDesc,
    completedTransfer,orderClose, orderRefund,orderRefunds, orderPreRefund,ticketOrdersCreate,
    vasOrdersCreate, ticketOrdersCreateAndCheckin,calculatePrice,luckMoneyOrders,rewardOrders,
    marketdOrders,rechargeOrder,orders,orderExport} = api
/**
 * 查找
 */
export async function findOrders(params) {
    return request({url: orders, method: 'get', data: params,})
}

/**
 * 查找
 */
export async function findOrder(params) {
    return request({url: order, method: 'get', data: params,})
}

/**
 * 查找列表
 */
export async function findTicketOrders(params) {
    return request({url: ticketOrders, method: 'get', data: params,})
}
/**
 * 查找列表
 */
export async function findVasOrders(params) {
    return request({url: vasOrders, method: 'get', data: params,})
}
/**
 * 查找红包列表
 */
export async function findLuckMoneyOrders(params) {
    return request({url: luckMoneyOrders, method: 'get', data: params,})
}
/**
 * 查找打赏列表
 */
export async function findRewardOrders(params) {
    return request({url: rewardOrders, method: 'get', data: params,})
}
/**
 * 查找会销列表
 */
export async function findMarketdOrders(params) {
    return request({url: marketdOrders, method: 'get', data: params,})
}

/**
 * 创建订单(购票和买服务)
 */
export async function createTicketOrder(params) {
    return request({url: ticketOrdersCreate, method: 'post', data: params,})
}
export async function createVasOrder(params) {
    return request({url: vasOrdersCreate, method: 'post', data: params,})
}
//主办方创建订单(购票和买服务)
export async function createImpTicketOrder(params) {
    return request({url: `${ticketOrdersCreate}?importFlag=true`, method: 'post', data: params,})
}
/**
 * 创建订单(购票和买服务)并签到
 */
export async function createTicketOrderAndCheckin(params) {
    return request({url: ticketOrdersCreateAndCheckin, method: 'post', data: params,})
}
/**
 * 调起支付
 */
export async function createPayinfo(params) {
    return request({url: payinfo, method: 'post', data: params,})
}


/**
 * 关闭订单
 */
export async function closeOrder(params) {
    return request({url: orderClose, method: 'post', data: params,})
}

/**
 * 退款订单
 */
export async function refundOrder(params) {
    return request({url: orderRefund, method: 'post', data: params,})
}
/**
 * 退款订单流水
 */
export async function refundsOrder(params) {
    return request({url: orderRefunds, method: 'get', data: params,})
}
/**
 * 查询可退余额
 */
export async function preRefundOrder(params) {
    return request({url: orderPreRefund, method: 'get', data: params,})
}


/**
 * 订单发货
 */
export async function deliverOrder(params) {
    return request({url: orderDeliver, method: 'post', data: params,})
}
/**
 * 完成转账
 */
export async function finishCompletedTransfer(params) {
    return request({url: completedTransfer, method: 'post', data: params,})
}
/**
 * 订单计算
 */
export async function totalCalculatePrice(params) {
    return request({url: calculatePrice, method: 'post', data: params,})
}

export async function updateOrderDesc(params) {
    return request({url: orderUpdateDesc, method: 'get', data: params,})
}

export async function createRechargeOrder(params) {
    return request({url: rechargeOrder, method: 'post', data: params,})
}

export async function expOrder(params) {
    return request({url: orderExport, method: 'get', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/cmOrder.js